import React from 'react';

import { Button, Group, Modal, Stack, Text, Title } from '@mantine/core';
import { AxiosError, AxiosResponse } from 'axios';
import { UseMutationResult } from 'react-query';
import { BillingPlan, BillingPlanWrite, ErrorMessage } from 'types';

interface IModalBillingPlanEditConfirmation {
  opened: boolean;
  handleClose: () => void;
  formId: string;
  updateBillingPlan: UseMutationResult<
    AxiosResponse<BillingPlan>,
    AxiosError<ErrorMessage>,
    BillingPlanWrite
  >;
}

const ModalBillingPlanEditConfirmation = ({
  opened,
  handleClose,
  formId,
  updateBillingPlan,
}: IModalBillingPlanEditConfirmation): JSX.Element => {
  return (
    <Modal
      centered
      opened={opened}
      onClose={handleClose}
      title={<Title order={4}>Attention</Title>}
      size='lg'
    >
      <Stack>
        <Text>
          Edits to this billing plan will not modify active packages attached to athletes. The changes will
          take effect on next renewal.
        </Text>
        <Text>
          Upcoming packages will be reapplied to the athlete using the modified billing plan information
          unless certain <b>*billing events</b> have occurred.
        </Text>
        <Text>
          <i>*Billing events</i>: invoices generated from this package have had any attempted charges
        </Text>
        <Group position='right'>
          <Button onClick={handleClose} variant='subtle'>
            Cancel
          </Button>
          <Button form={formId} type='submit' loading={updateBillingPlan.isLoading}>
            Confirm
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
};

export default ModalBillingPlanEditConfirmation;
